<template>
  <div class="footer bg-[#02182F] text-white text-[14px]">
    <div class="h-[500px] grid grid-cols-5 place-content-around gap-[40px]">
      <div class="col-span-3 h-full">
        <BottomMenus />
      </div>
      <div class="col-span-2 h-full">
        <div>联系我们</div>
        <div class="grid grid-cols-4 gap-[40px]">
          <div class="col-span-1">
            <div
              v-for="(item, index) in contact.code"
              :key="index"
            >
              <div class="text-[14px] my-[10px]">
                {{ item.name }}
              </div>
              <img
                :src="item.url"
              >
            </div>
          </div>
          <div class="col-span-3 flex flex-col justify-start items-start">
            <div
              v-for="(item, index) in contact.info"
              :key="index"
              class="mb-[30px]"
            >
              <div class="text-[14px] my-[10px]">
                {{ item.name }}:
              </div>
              <div class="text-[16px] leading-[14px] overflow-visible text-nowrap">
                {{ item.value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-[100px] flex justify-center items-center gap-4 text-white/90 text-base border-t-[1px] border-t-[#4B4B4B]">
      <span>
        备案号
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
        >
          沪ICP备2023022834号-1
        </a>
      </span>

      <span>
        <a
          href="https://beian.mps.gov.cn/#/query/webSearch"
          target="_blank"
          class="hover:text-bt-primary"
        >
          沪公网安备31010402334423号
        </a>
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
const contact = {
  code: [{
    name: '微信公众号',
    url: '/imgs/home/wechat.png',
  }],
  info: [
    { name: '邮箱', value: 'marketing@bangtu-ai.cn' },
    { name: '地址', value: '上海市徐汇区虹漕南路173号2号楼' },
    // { name: '服务热线', value: '400-234-678' },
  ],
}
</script>

<style lang="scss" scoped>
.footer {
  .logo {
    width: 115px;
    height: 80px;
    background-image: url('~/assets/imgs/home/logo-img.svg'), url('~/assets/imgs/home/logo-text-white.svg');
    background-repeat: no-repeat;
    background-position: left, right;
    background-origin: content-box;
    background-size: auto;
  }
}
</style>
